import { render, staticRenderFns } from "./DxAttachmentMachinaryTable.vue?vue&type=template&id=ae474924&"
import script from "./DxAttachmentMachinaryTable.vue?vue&type=script&lang=js&"
export * from "./DxAttachmentMachinaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports